module.exports = __webpack_public_path__ + "img/bitcoin-cuba-oro.5d90db00.jpg";